import { ComponentsProps, ComponentsOverrides, ComponentsVariants, linkClasses } from '@mui/material';
import { Theme } from '@mui/system/createTheme';
import { baseTheme } from '../base-theme';
import { generateFocusRingStyles } from './utils/focus';

const focusRingStyles = generateFocusRingStyles(linkClasses.focusVisible);

export const MuiLink: {
    defaultProps?: ComponentsProps['MuiLink'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiLink'];
    variants?: ComponentsVariants['MuiLink'];
} = {
    defaultProps: {
        variant: 'body1',
        color: 'primary',
    },
    variants: [
        {
            props: { color: 'primary' },
            style: {
                color: baseTheme.palette.text.secondary,
                textDecorationColor: baseTheme.palette.primary.main,
                [`&:hover`]: {
                    textDecorationColor: baseTheme.palette.primary.dark,
                },
            },
        },
    ],
    styleOverrides: {
        root: [
            {
                textUnderlineOffset: baseTheme.spacing(baseTheme.tokens.spacing.xxs),
                textDecorationThickness: '2px',
            },
            focusRingStyles,
        ],
    },
};
